<form [formGroup]="form">
  <div class="flex justify-center">
    <div class="w-full py-12 px-18.5">
      <div class="flex flex-col gap-2">
        <div
          class="w-full h-[200px] rounded-xl bg-gray-100 animate-pulse"></div>
        <div class="w-full h-[45.5px]"></div>
        <!-- TODO: remove ! from !text-* when bootstrap.css is removed. -->
        <input
          type="text"
          pInputText
          [pAutoFocus]="true"
          fluid="true"
          autocomplete="off"
          placeholder="What's your article about?"
          class="!text-5xl !border-none !shadow-none"
          [readonly]="isGenerating() ? 'readonly' : null"
          formControlName="title" />

        <p-divider />

        <div class="flex justify-between items-center">
          <div class="flex gap-2">
            <p-button
              label="Customize"
              size="large"
              variant="outlined"
              [rounded]="true"
              icon="pi pi-cog"
              severity="secondary"
              [disabled]="isGenerating()"
              (click)="handleCustomizeClick()" />
            <app-sources-button
              label="Sources"
              [sources]="form.get('sources').value"
              [maxSourceItems]="maxSourceItems"
              [disabled]="isGenerating()"
              (sourcesChange)="onSourcesChange($event)" />
            @if (featureFlags.projectCreation.startManually) {
              <app-start-manually-button
                [topic]="topic"
                [title]="title"
                [inputParams]="inputParams"
                [disabled]="isGenerating()" />
            }
            <p-button
              label="Generate"
              size="large"
              icon="pi pi-arrow-right"
              iconPos="right"
              [severity]="!form.valid ? 'secondary' : 'primary'"
              [disabled]="!form.valid || isGenerating()"
              [rounded]="true"
              (click)="goToScript()" />
          </div>
          <div class="flex gap-2">
            <div>
              <app-prompt-language-picker
                [disabled]="isGenerating()"
                [value]="this.form.get('promptLanguage').value"
                (valueChange)="onPromptLanguageChange($event)" />
            </div>
          </div>
        </div>
        @if (isGenerating()) {
          <div class="d-flex justify-content-center align-items-center gap-2">
            <div class="spinner-grow text-primary" role="status"></div>
            <div>Generating (might take up to 1 minute)...</div>
          </div>
        }
      </div>
    </div>
  </div>
</form>
